import {
  Component,
  OnInit,
  Input,
  ElementRef
} from '@angular/core';
import {HorizontalAlignment, VerticalAlignment} from '../enums/dropdown.enum';

@Component({
  selector: 'awair-dropdown-ul',
  templateUrl: './dropdown-ul.component.html',
  styleUrls: ['./dropdown-ul.component.scss']
})

export class DropdownUlComponent implements OnInit {

  left: string;
  right: string;

  bottom: string;

  @Input()
  set horizontalAlignment(value: HorizontalAlignment) {
    if (value != null) {
      [this.right, this.left] = value === HorizontalAlignment.Left ? ['auto', '0px'] : ['0px', 'auto'];
    }
  }

  @Input()
  set verticalAlignment(value: VerticalAlignment) {
    if (value != null) {
      const selfElement: HTMLElement = this.el.nativeElement;
      const parentHeight = selfElement.parentElement.clientHeight;

      if (value === VerticalAlignment.Top) {
        this.bottom = `${parentHeight}px`;
      }
    }
  }

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
  }
}
